import React, { Component, Fragment } from "react";
import Sticky from "Components/Sticky";
import Heading from "Components/Heading";
import Dropdown from "Components/Dropdown/dropdown";
import Checkbox from "Components/Checkbox/index";
import { DateRangePicker } from "react-dates";
import { ReactComponent as Back } from 'Icons/back.svg'
import { connect } from "react-redux";
import moment from "moment";
import { withRouter } from "react-router";
import { GET_ALL_MASTER_CONTRACTS, GET_FROM_ROUTE, GET_BRANCH_YARD_FILTERS, GET_CHILD_CONTRACT_TK11, GET_MASTER_CONTRACT_TK11, GET_LOCATION_DROPDOWN_VALUES } from "Constants/actionConstants";
import { getUser } from 'Utils/storage';
import { AiOutlineCloseCircle, AiOutlinePlusCircle, AiOutlinePlus, } from "react-icons/ai";
import Popup from 'reactjs-popup';
import MultiModeContractDetails from "./multiModeContractDetails";
import ActionLoader from "Components/ActionLoader/index";
import { ReactComponent as Location } from 'Icons/location.svg'
import { ReactComponent as YardIcon } from 'Icons/railFencing.svg'
import { ReactComponent as Arrow } from 'Icons/downArrow.svg'
import RetriggerPopup from "./retriggerPopup";
import { isEmami } from "Utils/index";
import ScreenTimeTrack from "Components/Common/ScreenTimeTrack/index";
import { screenInfoDetails } from 'Constants/screenInfoDetailsConstants';

class MultiModeGeneratedContracts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            search: null,
            offset: 0,
            limit: 10,
            startDate: null,
            endDate: null,
            focusedInput: null,
            data: [
                // { id: 1, masterNO: 123456, routeCode: "001123", From: "AWL Plant, Mudra", originYard: "Dhrub", Destination: "kishanganj", to: "Delhi", details: "details" },
                // { id: 2, masterNO: 123457, routeCode: "001124", From: "AWL Plant, Hazira", originYard: "Hazira Yard", Destination: "Adarsh Nagar", to: "Surat", details: "details" }
            ],
            temp: [],
            tempObj: [],
            yardData: [],
            fromToData: [],
            setFilterType: "isBranch",
            selectedFrom: "",
            selectedTo: "",
            selectedOrgin: "",
            selectedDestination: "",
            applyFilters: {}
        }
    }

    componentDidMount () {
        this.getAllMasterContracts();
        this.setBranchFromToData();
    }



    getAllMasterContracts = async (formID, formIdValue) => {
        const { selectedDestination, selectedFrom, selectedOrgin, selectedTo, startDate, endDate, search, limit, offset} = this.state;
        const {dispatch, selectedNavBranch} = this.props;
        const user = getUser();
        const data = {
            companyId: user.id,
            branchId: (selectedNavBranch || {}).branch_id || user.branchId ||  "1212",
            limit,
            offset,
            ...(selectedFrom && {from: selectedFrom}),
            ...(selectedTo && {to: selectedTo}),
            ...(selectedOrgin && {origin_yard: selectedOrgin}),
            ...(selectedDestination && {dest_yard: selectedDestination}),
            ...(startDate && { tenure_from: new Date(moment(startDate)).getTime() }),
            ...(endDate && { tenure_to: new Date(moment(endDate)).getTime() }),
            ...(search && search !== "" && { search: search }),
          }
          

        await dispatch({
            type: GET_ALL_MASTER_CONTRACTS,
            params: data,
            onSuccess: (data)=>{
            }
        })
    }

    onClickPagination = (type) => {
        let { offset } = this.state;
        if (type == 'previous' && offset > 0) {
            offset -= +10;
        } else if (type == 'next') {
            offset += +10;
        }
        this.setState({ offset }, () => {
            this.getAllMasterContracts()
        });
    }
  

    getBrachYardFilterData = (filterType, search, type, noRepeatCall)=>{
        const {dispatch} = this.props;
        const {setFilterType} = this.state;
        const user = getUser();
        const data = {
            companyId: user.id,
            ...(search ? { type: type, search: search } : {
                isBranch: filterType == "isBranch" ? true : false,
                isYard: filterType == "isYard" ? true : false
            })
        }
        dispatch({
            type: search ? GET_LOCATION_DROPDOWN_VALUES : GET_BRANCH_YARD_FILTERS,
            params: data,
            onSuccess: (data)=>{
                if(filterType == "isBranch"){
                    this.setState({
                        fromToData: search ? (data || []).map(val => {
                            return { city: val }
                        }) : data
                    });
                    if (!noRepeatCall){
                        this.getBrachYardFilterData("isYard")
                    }
                }else if (filterType == "isYard") {
                    this.setState({
                        yardData: search ? (data || []).map(val => {
                            return { branch_name: val }
                        }) : data
                    })
                }
            }
        })
    }

    setBranchFromToData = () =>{
        const isBranch = "isBranch";
        
        this.getBrachYardFilterData(isBranch)
    }

    setSelectedFrom = (item) => {
        this.setState({
            selectedFrom: item && typeof(item) == 'object' ? null : item
        }, this.getAllMasterContracts)
      }
    
      setSelectedTo = (item) => {
        this.setState({
            selectedTo: item && typeof(item) == 'object' ? null : item
        }, this.getAllMasterContracts)
      }
    
      setSelectedOrgin = (item) => {
        this.setState({
            selectedOrgin: item && typeof(item) == 'object' ? null : item
        }, this.getAllMasterContracts)
      }
    
      setSelectedDestination = (item) => {
         this.setState({
            selectedDestination: item && typeof(item) == 'object' ? null : item
        }, this.getAllMasterContracts)
      }
    

    setFiltersData = (item, formID) => {
      this.getValues(item, formID).then(() => {
          this.getAllMasterContracts(formID, item)
      })
  }
 
  selectYardData = (item) => {
    this.setState({
      yardData: item
    })
  }

    render() {
        // const temp = [{ id: 1, name: "Option1" }, { id: 2, name: "Option2" }, { id: 3, name: "Option3" }];
        const { temp, fromToData, setFilterType, yardData, selectedDestination, selectedFrom, selectedOrgin, selectedTo, limit, offset } = this.state;
        const { masterContractsLoading, totalCount } = this.props;
        const contentStyle = {
            width: "90%",
            height: "100%",
            // maxHeight: "80%",
            // overflowY: "scroll",
            background: "none",
            border: "none"
        }
        return (
            <Sticky>
                {masterContractsLoading && <ActionLoader fixed={true}/>}
                <div className="p-15">
                    <ScreenTimeTrack
                        screenInfoDetailsItem={
                            screenInfoDetails.VIEW_GENERATED_CONTRACTS_SCREEN
                        }
                    />
                    <div className=" curP fBold pb-10 "
                        onClick={() => {
                            this.props.history.goBack();
                        }
                        }>
                        <Back className="fill-theme mr-5" />
                        {'Back'}
                    </div>
                    <div className="flex flex-between" style={{ justifyContent: "space-between", alignItems: "center" }}>

                        <div className="mt-25 borderBox bg-white">
                            <Heading text="Master Contracts" className="flex-1 fs-23" />
                        </div>
                        <div className="fs-14 header-dark-color">
                            <button
                                className={"bg-theme wt-250 ht-40 br-5 fBold fs-14 white-color"}
                                onClick={() => {
                                    this.props.history.push('/createNewContracts')
                                }}
                            >+ Create New Contract</button>
                        </div>
                    </div>
                    <div className="mt-20"></div>
                    <Fragment>
                        <div className="flex" style={{ width: "100%", justifyContent: "space-between" }}>
                            <div style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "200px" }} className="fs-14 header-dark-color">
                                <input
                                    placeholder={"Search Master contract No. / Route No."}
                                    type="text"
                                    className="wt-200 ht-40 search"
                                    onChange={(e) => {
                                        this.setState({search: e.target.value}, this.getAllMasterContracts)
                                    }}
                                />
                            </div>
                            <div className="fs-14 header-dark-color ">
                                <Dropdown
                                    items={fromToData}
                                    canClear
                                    label="From"
                                    onSearchText={(text) => { if(isEmami()) return; this.getBrachYardFilterData('isBranch', text, 1, true) }}
                                    displayKey="city"
                                    selectedItem={fromToData.find((item)=>item.city == selectedFrom)}
                                    onSelect={this.setSelectedFrom}
                                    className="mb-0 wt-300"
                                    searchEnabled={true}
                                />
                            </div>

                            <div className="fs-14 header-dark-color">
                                <Dropdown
                                    items={fromToData}
                                    canClear
                                    onSearchText={(text) => { if(isEmami()) return; this.getBrachYardFilterData('isBranch', text, 2, true) }}
                                    selectedItem={fromToData.find((item) => item.city == selectedTo)}
                                    name="To"
                                    onSelect={this.setSelectedTo}
                                    displayKey="city"
                                    className="mb-0 wt-300"
                                    label="To"
                                    searchEnabled={true}
                                />
                            </div>
                            <div className="fs-14 header-dark-color">
                                <Dropdown
                                    items={yardData}
                                    canClear
                                    onSearchText={(text) => { if(isEmami()) return; this.getBrachYardFilterData('isYard', text, 3, true) }}
                                    selectedItem={yardData.find((item) => item.branch_name == selectedOrgin)}
                                    name="Origin Yard"
                                    onSelect={this.setSelectedOrgin}
                                    displayKey="branch_name"
                                    className="mb-0 wt-300"
                                    label="Origin Yard"
                                    searchEnabled={true}
                                />
                            </div>
                            <div className="fs-14 header-dark-color mr-10">
                                <Dropdown
                                    items={yardData}
                                    canClear
                                    onSearchText={(text) => { if(isEmami()) return; this.getBrachYardFilterData('isYard', text, 4, true) }}
                                    selectedItem={yardData.find((item) => item.branch_name == selectedDestination)}
                                    name="Origin Yard"
                                    onSelect={this.setSelectedDestination}
                                    displayKey="branch_name"
                                    className="mb-0 wt-300"
                                    label="Destination Yard"
                                    searchEnabled={true}
                                    
                                />
                            </div>
                            <div className="flex-between theme-font-color">
                                <DateRangePicker
                                    startDate={this.state.startDate} // momentPropTypes.momentObj or null,
                                    startDateId="start" // PropTypes.string.isRequired,
                                    endDate={this.state.endDate} // momentPropTypes.momentObj or null,
                                    endDateId="end" // PropTypes.string.isRequired,
                                    isOutsideRange={() => null}
                                    onDatesChange={({ startDate, endDate }) => this.setState({ startDate: startDate, endDate }, this.getAllMasterContracts)} // PropTypes.func.isRequired,
                                    focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                                />
                            </div>
                        </div>
                        <div className="flex fRight mt-10 pr-10 flex-middle theme-color fBold">
                            <span>{`${totalCount > 0 ? offset + 1 : 0} - ${totalCount < offset + limit ? totalCount : offset + limit} of ${totalCount}`}</span>                            
                            <Arrow onClick={() => { if (offset != 0) this.onClickPagination('previous') }} className={offset == 0 ? "fill-gray" : "curP"} style={{ width: '15px', height: '15px', marginLeft: '20px', transform: 'rotate(90deg)'}} />
                            <Arrow onClick={() => { if (totalCount >= (offset + limit)) this.onClickPagination('next') }} className={totalCount < (offset + limit) ? "fill-gray" : "curP"} style={{ width: '15px', height: '15px', marginTop: '2px', marginLeft: '20px', transform: 'rotate(270deg)' }} />
                        </div>
                        <table style={{ boxShadow: 'rgba(136, 165, 300, 0.6) 0px 0px 5px 0px, rgba(255, 255, 255, 0.7) 0px 0px 5px 0px', width: "100%", borderSpacing: '0px', marginTop: "40px" }}>
                            <thead className="ht-40 fs-14 fBold curP table-bg-blue white-color">
                                <tr className="br-10">
                                <th className='col-9 pl-10 pr-10 tCenter'>Master Contract No.</th>
                                    {!isEmami() && <th className='col-10 tCenter'>Route No.</th>}
                                    <th className='col-9 tCenter'>From</th>
                                    <th className='col-8 tCenter'>Origin Yard</th>
                                    <th className='col-8 tCenter'>Destination Yard</th>
                                    <th className='col-9 tCenter'>To</th>
                                    <th className='col-8 tCenter'>Contract Tenure From</th>
                                    <th className='col-8 tCenter'>Contract Tenure To</th>
                                    {/* <th className='col-9 tCenter'>Commodity</th> */}
                                    <th className='col-10 tCenter'>Details</th>
                                </tr>
                            </thead>
                            <tbody className="ht-40 fs-14 fBold mr-5 mt-10 curP label-color">
                                {(this.props.masterContracts || []).map((a, index) => {
                                    return (
                                        <tr className="ht-40">
                                            <td style={{ borderRight: "0px solid" }} className="tCenter p-5 pl-10 border-light fs-12 master-contract-font-color">{a.master_contract_number}</td>
                                            {!isEmami() && <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12">{a.route_code}</td>}
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12">
                                                <div style={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "10px" }}>

                                                    <Location style={{ height: '18px', width: '15px' }} />

                                                    {a.from}
                                                </div>

                                            </td>
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tLeft p-5 border-light fs-12">
                                                <div style={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "10px" }}>

                                                    <YardIcon style={{ height: '18px', width: '15px' }} />

                                                    {a.origin_yard}
                                                </div>
                                            </td>
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tLeft p-5 border-light fs-12">
                                                <div style={{ display: "flex", justifyContent: 'center', alignItems: "center", gap: "10px" }}>

                                                    <YardIcon style={{ height: '18px', width: '15px' }} />

                                                    {a.destination_yard}
                                                </div>
                                            </td>
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tLeft p-5 border-light fs-12">
                                                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>

                                                    <Location style={{ height: '18px', width: '15px' }} />

                                                    {a.to}
                                                </div>

                                            </td>
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12">
                                                {a.contract_tenure_from ? moment(a.contract_tenure_from).format('DD/MM/YYYY') : '-'}
                                            </td>
                                            <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12">
                                                {a.contract_tenure_to ? moment(a.contract_tenure_to).format('DD/MM/YYYY') : '-'}
                                            </td>
                                            {/* <td style={{ borderRight: "0px solid", borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12">xxx</td> */}
                                            <td style={{ borderLeft: "0px solid" }} className="tCenter p-5 border-light fs-12 theme-font-color">
                                                <span style={{ color: "#528aea" }} className={" fBold fs-14 "} onClick={() => { if (a && a.master_contract_id) this.props.history.push(`/viewContractDetails/${a.master_contract_id}`) }}>View</span>
                                            </td>
                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </Fragment>
                </div>
            </Sticky>
        )

    }
}

const mapStateToProps = ({ contracting, constants }) => {
    return {
        masterContracts: contracting.masterContracts.data || [],
        selectedNavBranch: constants.selectedNavBranch || {},
        masterContractsLoading: contracting.masterContracts.dataLoading,
        totalCount: contracting.masterContracts.totalCount
        // fromRoutes: contracting.fromRoutes.data || [],
    }
};

export default connect(mapStateToProps, null)(withRouter(MultiModeGeneratedContracts));
